import * as React from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import { withTranslation } from 'react-i18next';

import * as styles from './style.css';
import LayoutComponentsSpinner from "../spinner";

const Cloud = require('./icons/cloud.png');
const Cloud2x = require('./icons/cloud@2x.png');
const Theme = require('./icons/theme.png');
const Theme2x = require('./icons/theme@2x.png');

class LayoutComponentsLoaderGenerating extends React.PureComponent {

  static defaultProps = {
    opacity: 1,
    show: false,
    progress: null,
    showTheme: true
  };

  static propTypes = {
    opacity: PropTypes.number,
    show: PropTypes.bool,
    progress: PropTypes.number,
    showTheme: PropTypes.bool,
    isMemorialTheme: PropTypes.bool
  };

  render() {
    const containerStyle = this.props.isMemorialTheme ? { backgroundColor: '#252D76' } : { backgroundColor: `rgba(124,108,229,${this.props.opacity})` };
    const indicatorVisibility = this.props.progress ? 'visible' : 'hidden';
    return (
      <CSSTransition
        in={this.props.show}
        timeout={400}
        classNames="fade"
        unmountOnExit
        mountOnEnter>
        <div className={styles.modalContainer} style={containerStyle}>
          <div className={styles.inner}>
            <div className={`${styles.title} font-title`}>{ this.props.t('title') }</div>
            <div className={styles.subtitle}>{ this.props.t('subtitle') }</div>
            { !this.props.isMemorialTheme && <LayoutComponentsSpinner/>}
            <div className={styles.indicatorContainer}
                  style={{ visibility: indicatorVisibility }}>
              <div className={styles.indicatorMock}></div>
              <div className={styles.indicator} style={{ width: `${this.props.progress*94}%` }}></div>
            </div>
            <img src={Cloud} srcSet={Cloud2x} className={styles.cloudLeft} />
            <img src={Cloud} srcSet={Cloud2x} className={styles.cloudRight} />
            {this.props.showTheme && <img src={Theme} srcSet={Theme2x} className={styles.theme} />}
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default withTranslation('cmp-generating')(LayoutComponentsLoaderGenerating);


// WEBPACK FOOTER //
// ./src/app/modules/layout/ui/components/loader-generating/index.jsx